import Utils from "../../../../../shared/utils";

export const INFO_IMAGE = Utils.buildNewsletterLink("icons/info.svg");